import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
import Newuploader from "lib/mixins/Newuploader";
export default {
  name: "avatarUpload",
  mixins: [Newuploader],
  data: function data() {
    return {
      imageUrl: "",
      loading: false,
      hideUploader: false
    };
  },
  props: {
    minSize: {
      type: Number,
      default: 0
    }
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var that = this;

      if (file.size < this.minSize) {
        this.$message.warning({
          title: file.name,
          message: "图片应大于200k"
        });
        return false;
      }

      if (this.format === "image") {
        var isPngJpg = this.acceptTypes.includes(file.type);

        if (!isPngJpg) {
          this.$message.info({
            title: file.name,
            message: "只能上传 PNG / JPG 格式的图片"
          });
          return false;
        }
      }

      var fileData = file; //读取图片数据

      return new Promise(function (resolve) {
        var reader = new FileReader();

        reader.onload = function (e) {
          var data = e.target.result; //加载图片获取图片真实宽度和高度

          var image = new Image();
          image.src = data;

          image.onload = function () {
            var f = that.$refs.upload.uploadFiles;

            if (f.length > 1) {
              var uf = f[0];
              console.log(uf);
              that.$refs.upload.handleRemove(uf);
            }

            that.addFile(file).then(resolve);
            that.loading = true;
          };
        };

        reader.readAsDataURL(fileData);
      });
    },
    onRemoveHandler: function onRemoveHandler() {
      if (this.onRemove) {
        this.onRemove();
      }
    },
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      this.imageUrl = res.docPath; // 执行mixins里的onSuccess, 继续下一个文件

      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }

      if (res.code > 0) {
        file.url = res.docPath;
        this.$emit("update:docId", res.docId);
        this.loading = false;
      }
    }
  }
};